module.exports = __webpack_public_path__ + "static/media/tt_norms_medium.700e6c06.otf";